import { inputTypeTime } from '@components/input/index.js';

export default (settings = {}) => {
  const { fromNode, toNode } = settings;

  if (!fromNode || !toNode) {
    throw new Error('timeComponent');
  }

  inputTypeTime(fromNode);
  inputTypeTime(toNode);

  const containerNode = fromNode.closest('.input__field-group');

  const state = {
    value: {
      from: '',
      to: '',
    },
  };

  const normalizeValue = (value) => {
    if (typeof value === 'string') {
      return value ? JSON.parse(value) : { from: '', to: '' };
    }

    return value;
  };

  const setValue = (newValue = {}) => {
    const oldValue = state.value;

    state.value = {
      ...oldValue,
      ...normalizeValue(newValue),
    };
  };

  const getValue = (key = '') => {
    const { value } = state;
    const copyValue = { ...value };

    if (!key) {
      return copyValue;
    }

    if (Object.hasOwn(copyValue)) {
      return value[key];
    }

    return '';
  };

  const validate = (timeString) => {
    const { from, to } = normalizeValue(timeString);
    const timeRegExp = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;

    if (!from.match(timeRegExp) || !to.match(timeRegExp)) {
      return false;
    }

    return true;
  };

  const toString = () => {
    if (!validate(state.value)) {
      return '';
    }

    return JSON.stringify(state.value);
  };

  const renderValue = () => {
    const { from, to } = state.value;
    fromNode.value = from;
    toNode.value = to;
  };

  const renderValidity = (validityState = '') => {
    if (validityState === 'invalid') {
      containerNode.classList.add('_invalid');
      return;
    }

    containerNode.classList.remove('_invalid');
  };

  return {
    fromNode,
    toNode,
    validate,
    renderValidity,
    toString,
    getValue,
    setValue,
    update: (newValue) => {
      setValue(newValue);
      renderValue();
      renderValidity('idle');
      return getValue();
    },
    clear: () => {
      setValue('');
      renderValue();
      renderValidity('valid');
    },
  };
};
